import GATSBY_COMPILED_MDX from "/opt/buildhome/repo/src/posts/ember-dot-js-hello-world/index.mdx";
import {graphql} from "gatsby";
import React from "react";
import {Helmet} from "react-helmet";
import Header from "styleguide/components/Header";
import Layout from "styleguide/components/Layout";
import SEO from "styleguide/components/Seo";
import {WhatWeHaveDone} from "styleguide/page-components/Blog";
import {ArticleContent, ArticleHero} from "styleguide/page-components/BlogArticle";
const currentHost = siteUrl => {
  if (typeof window !== "undefined") {
    return window.location.host;
  }
  return siteUrl;
};
const BlogArticle = ({data, location, children}) => {
  const {frontmatter, excerpt} = data.mdx;
  const {siteUrl} = data.site.siteMetadata;
  return React.createElement(React.Fragment, null, React.createElement(Helmet, null, React.createElement("link", {
    rel: "canonical",
    href: `${currentHost(siteUrl)}${location.pathname}`
  })), React.createElement(Header), React.createElement(SEO, {
    title: frontmatter.title,
    description: excerpt,
    image: !!frontmatter.featuredImage && `${currentHost(siteUrl)}${frontmatter.featuredImage.childImageSharp.fluid.src}`,
    isArticle: true
  }), React.createElement(Layout, {
    header: React.createElement(ArticleHero, {
      breadcrumb: frontmatter.title
    }),
    main: React.createElement(React.Fragment, null, React.createElement(ArticleContent, {
      body: children,
      title: frontmatter.title,
      author: frontmatter.author,
      date: frontmatter.date,
      link: `${currentHost(siteUrl)}${location.pathname}`,
      categories: frontmatter.categories
    }), React.createElement(WhatWeHaveDone))
  }));
};
BlogArticle
export default function GatsbyMDXWrapper(props) {
  return React.createElement(BlogArticle, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const query = graphql`
  query PostsBySlug($slug: String!) {
    mdx(fields: { slug: { eq: $slug } }) {
      body
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        author
        categories
        featuredImage {
          childImageSharp {
            fluid(maxHeight: 500, quality: 90, cropFocus: CENTER) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
      excerpt(pruneLength: 200)
    }
    site {
      siteMetadata {
        siteUrl
      }
    }
  }
`;
